import { useEffect, useState } from 'react';
import LocalisationService from '@services/LocalisationService';
const useLocales = () => {
    const [locales, setLocales] = useState([]);
    useEffect(() => {
        LocalisationService.load().then((data) => {
            setLocales(data);
        });
    }, []);
    return [locales, setLocales];
};
export default useLocales;
